export const FETCH_DEPARTMENTS_REQUEST = 'FETCH_DEPARTMENTS_REQUEST';
export const FETCH_DEPARTMENTS_SUCCESS = 'FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_FAILURE = 'FETCH_DEPARTMENTS_FAILURE';

export const FETCH_DEPARTMENTS_RELEASE_REQUEST = 'FETCH_DEPARTMENTS_RELEASE_REQUEST';
export const FETCH_DEPARTMENTS_RELEASE_SUCCESS = 'FETCH_DEPARTMENTS_RELEASE_SUCCESS';
export const FETCH_DEPARTMENTS_RELEASE_FAILURE = 'FETCH_DEPARTMENTS_RELEASE_FAILURE';

export const FETCH_DEPARTMENT_REQUEST = 'FETCH_DEPARTMENT_REQUEST';
export const FETCH_DEPARTMENT_SUCCESS = 'FETCH_DEPARTMENT_SUCCESS';
export const FETCH_DEPARTMENT_FAILURE = 'FETCH_DEPARTMENT_FAILURE';

export const UPDATE_DEPARTMENTS_REQUEST = 'UPDATE_DEPARTMENTS_REQUEST';
export const UPDATE_DEPARTMENTS_SUCCESS = 'UPDATE_DEPARTMENTS_SUCCESS';
export const UPDATE_DEPARTMENTS_FAILURE = 'UPDATE_DEPARTMENTS_FAILURE';

export const DELETE_DEPARTMENTS_REQUEST = 'DELETE_DEPARTMENTS_REQUEST';
export const DELETE_DEPARTMENTS_SUCCESS = 'DELETE_DEPARTMENTS_SUCCESS';
export const DELETE_DEPARTMENTS_FAILURE = 'DELETE_DEPARTMENTS_FAILURE';

export const OPEN_EDIT_PAGE_DEPARTMENT = 'OPEN_EDIT_PAGE_DEPARTMENT';
export const OPEN_EDIT_PAGE_DEPARTMENT_SUCCESS = 'OPEN_EDIT_PAGE_DEPARTMENT_SUCCESS';

export const CLEAR_DEPARTMENT_ERRORS = 'CLEAR_DEPARTMENT_ERRORS';
export const CLEAR_DEPARTMENT_SUCCESS = 'CLEAR_DEPARTMENT_SUCCESS';